import { memo } from "react";
import { Button, ButtonProps } from "../../../../Button";
import { Tooltip } from "../../../../Tooltip";
import { useTablePropsContext } from "../../../context";
import { useSettingsContext } from "../SettingsContext";

import { ReactComponent as SettingsIcon } from "../icons/settings.svg";

export const SettingsButton = memo<ButtonProps>((props) => {
  const tableProps = useTablePropsContext();
  const { setIsOpen } = useSettingsContext();

  if (tableProps?.hideSettings) {
    return null;
  }

  return (
    <Tooltip content={"Settings"}>
      <Button
        buttonSize="md"
        buttonType="secondaryGray"
        {...props}
        onClick={() => setIsOpen(true)}
        iconOnly
      >
        <SettingsIcon />
      </Button>
    </Tooltip>
      
  );
});